import axios from "axios";
import { createInstance } from "./interceptors/createInstance";

const { isCancel, CancelToken } = axios;

export { createInstance, isCancel, CancelToken };

export { default as useFetch } from "./hooks/useFetch";
